import React from "react";
import "../styles/main.css";

import "react-lazy-load-image-component/src/effects/opacity.css";

import VFB_mainPage from "../components/VFB_mainPage";
import VFB_Features from "../components/VFB_Features";
import VFB_Features2 from "../components/VFB_Features2";
import VFB_Features3 from "../components/VFB_Features3";
import FAQ from "../components/FAQs";
import { faqsBroadcasters } from "../components/FAQs_QandAOnly";
import  Contact  from "../components/Contact";
import Footer from "../components/Footer";

const VupopForBroadcasters= () => {
  return (

    <>
    <VFB_mainPage/>
    <VFB_Features />
    <VFB_Features2 />
    <VFB_Features3 />
    <FAQ questions={faqsBroadcasters} />
    <Footer/>
    </>
  );
};

export default VupopForBroadcasters;

